import Filter from "../core/Filter";
import FadeAnimation from "./FadeAnimation";
import LazyLoad from "vanilla-lazyload";
import Rellax from "rellax";

export default class ResourceJobModuleFilter extends Filter {
    init() {
        this.resourceJobModuleMainWrapper = document.querySelector(".js-resource-job-module-list-wrapper");
        this.resourceJobModuleFilterList = document.querySelectorAll(".js-resource-job-module-filters");

        if (this.resourceJobModuleMainWrapper) {
            this.setDefaultFilterActiveClass();
            this.eventFilters();
        }
    }

    setParams() {
        let params = "?resource-jobs-location=";

        let resourceJobModuleLocation = document.querySelector('a[data-type="resource-job-module"].is-active');

        if (resourceJobModuleLocation) {
            params += resourceJobModuleLocation.getAttribute("data-slug");
        }

        if (this.resourceJobModuleMainWrapper.getAttribute("data-current-url")) {
            params += "&current-url=" + this.resourceJobModuleMainWrapper.getAttribute("data-current-url");
        }

        return params;
    }

    setDefaultFilterActiveClass() {
        let resourceJobModuleFilterItems = document.querySelectorAll('a[data-type="resource-job-module"]');

        if (resourceJobModuleFilterItems.length > 0) {
            for (let i = 0; i < resourceJobModuleFilterItems.length; i++) {
                if (resourceJobModuleFilterItems[i].classList.contains("is-active")) {
                    return;
                }
            }

            resourceJobModuleFilterItems[0].classList.add("is-active");
        }
    }

    eventFilters() {
        if (this.resourceJobModuleFilterList.length > 0) {
            for (let i = 0; i < this.resourceJobModuleFilterList.length; i++) {
                this.resourceJobModuleFilterList[i].addEventListener("click", (event) => {
                    event.preventDefault();

                    if (this.isFilterInProgress()) {
                        return;
                    }
                    this.disableFilter();

                    if (event.target) {
                        let current = event.target;
                        let currentFilter = document.querySelector('a[data-type="resource-job-module"].is-active');

                        if (currentFilter !== null) {
                            currentFilter.classList.remove("is-active");
                        }

                        current.classList.add("is-active");

                        this.ajaxFilter();
                    }
                });
            }
        }
    }

    ajaxFilter() {
        let url = this.getApiUrlFromElement(".js-resource-job-module-list-wrapper");

        let params = this.setParams();

        console.log(params);

        this.loadAjax(url, params);
    }

    afterFilterAjax(response) {
        let data = JSON.parse(response);

        if (data.html) {
            this.resourceJobModuleMainWrapper.innerHTML = data.html;
        }

        if (data.url) {
            let stateData = {
                page: data.page,
                url: data.url,
                random: Math.random(),
                source: "swup",
            };

            this.updateUrls(stateData, data.url);
        }

        this.enableFilter();

        const fadeAnimation = new FadeAnimation();
        fadeAnimation.init();

        /**
         * Lazyload init
         */
        const lazyLoad = new LazyLoad({
            elements_selector: ".js-lazy",
        });

        /**
         * parallax init
         */
        const rellax = new Rellax(".rellax", {
            speed: -2,
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false,
        });
    }
}
